module.exports = __webpack_public_path__ + "img/locked-icon.2b52e97f.svg";